export default "__VITE_ASSET__Dfq1XfbV__"